import React from 'react'
import useAuth from '../hooks/useAuth'
import { Navigate, Outlet } from 'react-router-dom'
import { NavList } from '../utils/constants/navigation'

const PrivateRoute = () => {
  const user = useAuth()
  
  return  user === 1 || user === 2 ? <Outlet /> : <Navigate to={NavList.HOMEPAGE} />
}

export default PrivateRoute